export function getView(type, blocked_time_permission) {
  return type === 'note' && blocked_time_permission
}
